import { render, staticRenderFns } from "./dynamic.vue?vue&type=template&id=6468fc56"
import script from "./dynamic.vue?vue&type=script&lang=js"
export * from "./dynamic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6468fc56')) {
      api.createRecord('6468fc56', component.options)
    } else {
      api.reload('6468fc56', component.options)
    }
    module.hot.accept("./dynamic.vue?vue&type=template&id=6468fc56", function () {
      api.rerender('6468fc56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gen/dynamic.vue"
export default component.exports